exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button-module__container--3cUS6 {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.Button-module__icon--3sBbl {\r\n  /*position: absolute;*/\r\n  margin-right: 8px;\r\n}\r\n\r\n.Button-module__titleSNS--3wDxf {  \r\n  font-family: Noto Sans KR;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #ffffff;\r\n  letter-spacing: 0px;\r\n}\r\n\r\n.Button-module__title--PlWjm {  \r\n  font-family: Noto Sans KR;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #ffffff;\r\n  letter-spacing: 0px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "Button-module__container--3cUS6",
	"icon": "Button-module__icon--3sBbl",
	"titleSNS": "Button-module__titleSNS--3wDxf",
	"title": "Button-module__title--PlWjm"
};